export type RedemptionsListItemDto = {
  redemptionId: number;
  redemptionDate: string;
  locatorId: string;
  status: 'Solicitado' | 'Aprovada' | 'Rejeitada' | 'Finalizada';
  redemptionValue: number;
  redeemingInvoiceNumber: string;
  redeeminginvoiceseries: string;
  invoicesToMatch: string;
  rejectionReason: string;
  rejectionDetails: string;
};

export class RedemptionsListItem {
  redemptionId!: string;
  redemptionDate!: string;
  locatorId!: string;
  status!: 'Solicitado' | 'Aprovado' | 'Recusado' | 'Pago';
  redemptionValue!: string;
  redeemingInvoiceNumber!: string;
  redeeminginvoiceseries!: string;
  invoicesToMatch!: string;
  rejectionReason!: string;
  rejectionDetails!: string;

  constructor(data: RedemptionsListItem | RedemptionsListItemDto) {
    if (!(data instanceof RedemptionsListItem)) {
      this.redemptionId = data.redemptionId.toString();
      this.redemptionDate = new Date(data.redemptionDate).toLocaleString();
      this.locatorId = data.locatorId;
      this.status = {
        Solicitado: 'Solicitado',
        Aprovada: 'Aprovado',
        Rejeitada: 'Recusado',
        Finalizada: 'Pago',
      }[data.status] as any;
      this.redemptionValue = this.formatCurrency(data.redemptionValue);
      this.redeemingInvoiceNumber = data.redeemingInvoiceNumber;
      this.redeeminginvoiceseries = data.redeeminginvoiceseries;
      this.invoicesToMatch = data.invoicesToMatch;
      this.rejectionReason = data.rejectionReason;
      this.rejectionDetails = data.rejectionDetails;
      return;
    }

    this.redemptionId = data.redemptionId;
    this.redemptionDate = data.redemptionDate;
    this.locatorId = data.locatorId;
    this.status = data.status;
    this.redemptionValue = data.redemptionValue;
    this.redeemingInvoiceNumber = data.redeemingInvoiceNumber;
    this.redeeminginvoiceseries = data.redeeminginvoiceseries;
    this.invoicesToMatch = data.invoicesToMatch;
    this.rejectionReason = data.rejectionReason;
    this.rejectionDetails = data.rejectionDetails;
  }

  toRaw() {
    return { ...this };
  }

  private formatCurrency(value: unknown): string {
    if (isNaN(parseFloat(value as any))) return '-';

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })
      .format(Number(value))
      .replace(' ', ' ');
  }
}
